function removeLastSlash(path) {
    return path.endsWith('/') ? path.slice(0, -1) : path;
}

export default {
    pathsEqual(path1, path2) {
        return removeLastSlash(path1) === removeLastSlash(path2);
    }
}